import {
	ElementRef,
	Injectable,
	Renderer2,
	RendererStyleFlags2,
} from '@angular/core';

@Injectable()
export class SimulationViewProvider {
	private readonly GAP_PX = 16;
	public adjustHeight(elemRef: ElementRef, renderer: Renderer2): void {
		const queryParamsSection = elemRef.nativeElement.querySelector(
			'.subscription-simulator__query-params .app-panel-content'
		);

		const simulationColumnList = elemRef.nativeElement.querySelector(
			'.app-subscription-simulation-column-config'
		);

		if (!queryParamsSection || !simulationColumnList) {
			return;
		}

		const simulationColumnListHeight =
			queryParamsSection.offsetHeight - this.GAP_PX;

		renderer.setStyle(
			simulationColumnList,
			'--max-height-simulation-columns',
			`${simulationColumnListHeight}px`,
			RendererStyleFlags2.DashCase
		);
	}
}
